<template>
  <div class="keep-alive">
    <div
      :key="item.path"
      class="keep-alive-item"
      v-for="(item) in list"
    >
      <template v-if="item.name">
        <router-link :to="{ path: item.path }" exact>
          <span
            v-if="item.name === '患者信息'"
          >{{ item.params.name }}</span>
          <span
            v-else-if="item.params.target"
          >{{ `${item.name} [${item.params.target}]` }}</span>
          <span v-else>{{ item.name }}</span>
        </router-link>
        <i
          @click="removeItem(item)"
          class="el-icon-close"
          v-if="item.name !== '医生列表'"
        ></i>
      </template>
    </div>
    <div class="tags-manager">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          关闭操作
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="removeOther">关闭其他标签</el-dropdown-item>
          <el-dropdown-item @click.native="removeAllItem">关闭所有标签</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import $store from '@/model/store/index'

export default {
  name: 'TheTab',
  computed: {
    ...mapState({
      list: state => state.keepAlive.list
    })
  },
  methods: {
    removeItem(item) {
      $store.commit('removed', item)
      const length = this.list.length
      if (length) {
        const route = this.list[length - 1]
        if (item.path === this.$route.path) {
          this.$router.replace(route)
        }
      } else {
        this.$router.replace({ path: '/' })
      }
    },
    removeOther() {
      $store.commit('removeOther', this.$route)
    },
    removeAllItem() {
      $store.commit('removeAll')
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.keep-alive {
  position: relative;
  height: 40px;
  font-size: 0;
  white-space: nowrap;
  background-color: $white;
  overflow-x: auto;
  &-item {
    position: relative;
    margin-top: 9px;
    margin-bottom: 8px;
    padding: 2px 15px 4px 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
    display: inline-block;
    & > a.actived {
      color: $primary;
    }
    .el-icon-close {
      position: absolute;
      top: 0;
      right: 2px;
      cursor: pointer;
      transform: scale(0.8, 0.8);
    }
  }
}
.tags-manager {
  position: absolute;
  top: 13px;
  right: 0;
  .el-dropdown-link {
    padding: 0 15px 0 10px;
    border-radius: 0;
    border-left: 1px solid #ccc;
    line-height: 14px;
    color: #999;
    user-select: none;
  }
}
</style>
